import React, { useEffect, useState } from 'react';
import { useAppDispatch } from 'hooks/redux';
import { findIndex, isEqual } from 'lodash';
import AsyncSelect from 'react-select/async';
import { setElementValues } from 'store/rfiSlice';
import { answerValueTypes, elementTypes, IElementProps } from 'types/RfiTypes';

type OptionType = {
  value: string;
  label: string;
  disabled: boolean;
};

const SelectionList = (props: IElementProps) => {
  // Hooks
  const dispatch = useAppDispatch();

  // State

  // let defaultValues: string[] = [];
  // props.element.answers?.map((answer: any) => {
  //   defaultValues.push(answer?.value);
  // });

  const [value, setValue] = useState<string>(
    props.element.answers ? props.element.answers[0]?.value ?? "" : ""
  );
  const [values, setValues] = useState<string[]>(
    props.element.answers?.map((answer: any) => {
      return answer?.value;
    }) ?? [""]
  );
  const [options, setOptions] = useState<OptionType[]>(() => {
    return (
      props.element.options?.map((result: any) => {
        return labelFormatter(result);
      }) ?? []
    );
  });
  // const [hasOptionsChanged, setOptionsChanged] = useState<boolean>(false);
  // const [hasOtherChanged, setOtherChanged] = useState<boolean>(false);
  // const [checkedValues, setCheckedValues] = useState<ElementValue[]>(() => {
  //   return props.element.answers
  //     ? cloneDeep(props.element.answers)
  //         .filter(
  //           (answer: ElementAnswer) =>
  //             answer?.answerValueType === answerValueTypes.OPTION &&
  //             props.element.options?.find(
  //               (option: ElementOption) =>
  //                 option?.type === optionTypes.DEFAULT &&
  //                 option?.value &&
  //                 option.value === answer.value
  //             )
  //         )
  //         ?.map((a: ElementAnswer) => {
  //           return {
  //             value: a?.value ?? "",
  //             answerValueType: answerValueTypes.OPTION,
  //           };
  //         }) ?? []
  //     : [];
  // });

  // Functions
  const labelFormatter = (i: any): OptionType => {
    return {
      label: i.description,
      value: i.value,
      disabled: false,
    };
  };

  // Handlers
  const handleChange = (e: any) => {
    let values: any = [];
    if (e !== null && typeof e.length !== "undefined") {
      e.forEach((answer: any) => {
        values.push({
          value: answer?.value,
          answerValueType: answerValueTypes.OPTION,
        });
      });
      let newValues: string[] = [];
      values?.map((answer: any) => {
        newValues.push(answer?.value);
      });
      setValues(newValues);
    } else {
      values.push({
        value: e?.value,
        answerValueType: answerValueTypes.OPTION,
      });
      setValues([e?.value]);
    }

    dispatch(
      setElementValues({
        elementId: props.element.elementId,
        values: values,
      })
    );
  };

  // Effects
  useEffect(() => {
    if (props.element.options) {
      let resp: OptionType[] = props.element.options?.map((result: any) => {
        return labelFormatter(result);
      });
      setOptions(resp);
    }
  }, [props.element.options]);

  // Render
  if (props.element.elementType === elementTypes.FIELD) {
    if (props.readOnly) {
      return (
        <div className="form-group row">
          <div className="col-lg-3 col-form-label">
            {props.element.fieldLabel}
          </div>
          <div className="col-lg-8 fieldElement">
            {props.isMulti
              ? values.map((localValue, index: number) => {
                  const descriptionText =
                    (
                      props.element.options &&
                      props.element.options.find(
                        (option) => option?.value === localValue
                      )
                    )?.description ?? localValue;
                  if (index === 0) {
                    return descriptionText;
                  } else {
                    return `; ${descriptionText}`;
                  }
                })
              : (
                  props.element.options &&
                  props.element.options.find(
                    (option) => option?.value === value
                  )
                )?.description ?? value}
          </div>
        </div>
      );
    } else
      return (
        <div className="form-group row">
          <div className="col-lg-3 col-form-label">
            <legend className="visuallyHidden">
              {props.element.fieldLabel}
            </legend>
            <label
              className="col-form-label"
              htmlFor={`lookup-${props.element.elementId}`}
            >
              <div>
                {props.element.fieldLabel}{" "}
                {props.overrideRequired === undefined ? (
                  props.element.requiredResponse ? (
                    <span className="requiredField">(required)</span>
                  ) : (
                    ""
                  )
                ) : props.overrideRequired === true ? (
                  <span className="requiredField">(required)</span>
                ) : (
                  ""
                )}
              </div>
            </label>
          </div>
          <div className="col-lg-8 fieldElement">
            {props.element.options && (
              <AsyncSelect
                onChange={handleChange}
                inputId={`select-${props.element.elementId}`}
                //defaultOptions
                isMulti={props.isMulti}
                isClearable={true}
                value={
                  values
                    ? values.map((item) => {
                        let index = findIndex(options, (option: any) => {
                          return option.value === item;
                        });
                        if (index >= 0) {
                          return options[index];
                        }
                      })
                    : null
                }
                defaultOptions={options}
                isSearchable={false}
              />
            )}
          </div>
        </div>
      );
  } else {
    if (props.readOnly) {
      return (
        <>
          <div>
            {`${props.questionNumber}.`} {props.element.fieldLabel}
          </div>
          <div>
            <AsyncSelect
              onChange={handleChange}
              inputId={`select-${props.element.elementId}`}
              //defaultOptions
              isMulti={props.isMulti}
              isClearable={true}
              value={null}
              defaultOptions={options}
              isSearchable={false}
              isOptionDisabled={() => true}
            />
          </div>
        </>
      );
    } else
      return (
        <>
          <fieldset className="usa-fieldset-inputs usa-sans">
            <legend className="visuallyHidden">
              {props.element.fieldLabel}
            </legend>
            <label
              className="col-form-label"
              htmlFor={`lookup-${props.element.elementId}`}
            >
              <div>
                {`${props.questionNumber}.`} {props.element.fieldLabel}{" "}
                {props.overrideRequired === undefined ? (
                  props.element.requiredResponse ? (
                    <span className="requiredField">(required)</span>
                  ) : (
                    ""
                  )
                ) : props.overrideRequired === true ? (
                  <span className="requiredField">(required)</span>
                ) : (
                  ""
                )}
              </div>
            </label>
            <div>
              <AsyncSelect
                onChange={handleChange}
                inputId={`select-${props.element.elementId}`}
                //defaultOptions
                isMulti={props.isMulti}
                isClearable={true}
                value={
                  values
                    ? values.map((item) => {
                        let index = findIndex(options, (option: any) => {
                          return option.value === item;
                        });
                        if (index >= 0) {
                          return options[index];
                        }
                      })
                    : null
                }
                defaultOptions={options}
                isSearchable={false}
              />
            </div>
          </fieldset>
        </>
      );
  }
};

const areEqual = (prevProps: IElementProps, nextProps: IElementProps) => {
  return (
    !prevProps.rerender &&
    isEqual(prevProps.element, nextProps.element) &&
    isEqual(prevProps.designMode, nextProps.designMode) &&
    isEqual(prevProps.readOnly, nextProps.readOnly)
  );
};

const SelectionListElement = React.memo(SelectionList, areEqual);

export default SelectionListElement;
